import { useMutation } from '@tanstack/react-query';

interface CompleteTutorialResponse {
  success: boolean;
}

export default function usePostOrganizationTutorialComplete() {
  return useMutation({
    mutationFn: async (tutorialId: number) => {
      const response = await fetch(`/agent/api/organization_tutorials/${tutorialId}/complete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token':
            document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to complete tutorial');
      }

      const data: CompleteTutorialResponse = await response.json();
      return data;
    },
  });
}
